import React from "react"

import { useDarkMode } from "../../context/DarkModeContext"

const DarkModeToggle = () => {
    const { isDarkMode, toggleDarkMode } = useDarkMode()

    const lightTextColor = !isDarkMode ? "text-yellow-600" : "text-gray-400"
    const darkTextColor = isDarkMode ? "text-blue-400" : "text-gray-400"
    
    // Material Design inspired toggle styles
    const toggleTrackColor = isDarkMode 
        ? "bg-white" 
        : "bg-blue-300"
    const toggleThumbColor = "bg-white"
    const togglePosition = isDarkMode ? "translate-x-5" : "translate-x-0"
    const toggleShadow = isDarkMode 
        ? "shadow-lg" 
        : "shadow-md border border-gray-200"

    return (
        <div className="flex items-center space-x-4">
            { /* Light mode text - only show when dark mode is active */ }
            { !isDarkMode && (
                <span
                    className={ `text-sm font-semibold transition-colors duration-300 ${ lightTextColor }` }
                >
                    Light Mode
                </span>
            ) }

            { /* Material Design Toggle Switch */ }
            <label className="relative inline-flex items-center cursor-pointer p-2 rounded-lg 
                 transition-colors duration-300">
                <input
                    type="checkbox"
                    className="sr-only"
                    checked={ isDarkMode }
                    onChange={ toggleDarkMode }
                    aria-label={ isDarkMode ? "Switch to light mode" : "Switch to dark mode" }
                />
                <div className="relative w-11 h-6 rounded-full transition-colors duration-300 
                     bg-red-400 bg-primary-100" >
                    <div
                        className={ `absolute top-0.5 left-0.5 w-5 h-5 rounded-full transition-all duration-300 
                            ${ togglePosition } ${ toggleThumbColor } ${ toggleShadow }` }
                    />
                </div>
            </label>

            { /* Dark mode text - only show when light mode is active */ }
            { isDarkMode && (
                <span className={ `text-sm font-semibold transition-colors duration-300 ${ darkTextColor }` }>
                    Dark Mode
                </span>
            ) }
        </div>
    )
}

export default DarkModeToggle
